module.exports = {"contestants":[{"id":1,"name":"Bill's Donut Shop","image":"0720-bills-donut-shop2.jpg"},{"id":2,"name":"Stan the Donut Man","image":"stan_the_donut_man.jpg"},{"id":3,"name":"Duck's Donuts","image":"041218_Duck_donuts_14.jpg"},{"id":4,"name":"Donuts R Us","image":"donuts-431863_1280.jpg"},{"id":5,"name":"Do or Donut","image":"donuts-690281_1280.jpg"}]}


//////////////////
// WEBPACK FOOTER
// ./src/json/sample_contestant_list.json
// module id = 47
// module chunks = 1